<div class="region-name" *ngIf="regionNameArr && isAdminView">
    <span class="text-center" *ngFor="let region of regionNameArr; let i = index" [ngClass]="i > 2 ? 'd-none' : ''">
        {{region}}
    </span>
</div>
<div [ngClass]="type === 'bar' ? 'bars-chart': ''" [attr.id]="bindTo"></div>
<div *ngIf="showLegend" class="row chart-legend" [ngClass]="type === 'bar' ? 'ml-1': ''">
    <div class="col-4 pr-0 text-center">
        <p>Complete</p>
        <span class="workflow-complete">{{value.completed}}</span>
    </div>
    <div class="col-4 px-0 text-center">
        <p>In Progress</p>
        <span class="workflow-inprogress">{{value.inprogress}}</span>
    </div>
    <div class="col-4 pl-0 text-center last-legent-margin">
        <p>Not Started/ Ready to Start</p>
        <span class="workflow-notstarted">{{value.notStarted}}</span>
    </div>
</div>
